import {Inject, Injectable, Optional} from '@angular/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment-timezone';
import {CUSTOM_DATE_FORMAT} from './DateUtil';
import {environment} from '../../../../environments/environment';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {

  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
    @Optional() @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS) options: any
  ) {
    super(dateLocale, options);
  }

  format(date: moment.Moment): string {
    return moment(date).tz(environment.timeZone).format(CUSTOM_DATE_FORMAT.parse.dateInput);
  }

}
